module.exports = __webpack_public_path__ + "img/gregory-circle.bb47238b.png";